var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"generic"},[_c('div',{staticClass:"fullwidth narex"},[_c('div',{staticClass:"right-padding"},[_c('editable-item',{attrs:{"page":_vm.pageName,"item":"text","loaded":_vm.loaded}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }